import { Component, ElementRef, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { select } from 'd3-selection';

import { CssMediaService } from '../../lib/media.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'se-togglebutton',
    templateUrl: './se-togglebutton.component.html',
    styleUrls: ['./se-togglebutton.component.less', './se-togglebutton.component.mobile.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SeToggleButtonComponent),
            multi: true,
        },
    ],
    standalone: true,
    imports: [NgClass],
})
export class SeToggleButtonComponent implements ControlValueAccessor, OnDestroy, OnInit {
    // events

    @Output()
    toggleChange = new EventEmitter<boolean>();
    @Input()
    source: string;

    // Data Members
    @Input()
    title: string;
    @Input()
    small = false;
    @Input()
    smaller = false;
    @Input()
    isPressed = false;
    @Input()
    isClicked = false;
    @Input()
    tooltip: string;

    constructor(
        private elementRef: ElementRef,
        public cssMediaService: CssMediaService,
    ) {}

    // Constructor

    @Output()
    propagateChange = (_: any) => {
        /* This is intentional */
    };

    // public functions

    ngOnInit() {
        select(this.elementRef.nativeElement)
            .on('mousedown', () => {
                this.isClicked = true;
            })
            .on('mouseup', () => {
                this.isClicked = false;
            });

        select(this.elementRef.nativeElement).on('click', () => {
            this.isPressed = !this.isPressed;
            this.propagateChange(this.isPressed);
            this.toggleChange.emit(this.isPressed);
        });
    }

    ngOnDestroy() {
        select(this.elementRef.nativeElement).on('mousedown', null).on('mouseup', null).on('click', null);
    }

    writeValue(obj: any): void {
        if (obj !== undefined) this.isPressed = obj;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(_fn: any): void {
        // This is intentional
    }

    setDisabledState(_isDisabled: boolean): void {
        // This is intentional
    }
}
